import React from "react";
import { Button, Modal } from "semantic-ui-react";

const PreviewModal = ({
    categoryName,
    categoryDiv,
    subDivision,
    question,
    option1,
    option2,
    option3,
    option4,
    answer,
    reference,
    open,
    close,
    checkInput
}) => {
    console.log("on preview modal ", open);
    return (
        <div>
            <Modal size="small" open={open} onClose={close}>
                <Modal.Header>Question Preview</Modal.Header>
                <Modal.Content>
                    <p>
                        <b>Category Name:</b> <em>{categoryName}</em>
                    </p>
                    {categoryDiv && (
                        <p>
                            <b>Category Division:</b> <em>{categoryDiv}</em>{" "}
                        </p>
                    )}
                    {subDivision && (
                        <p>
                            <b>Sub Division:</b>
                            <em>{subDivision}</em>{" "}
                        </p>
                    )}
                    <p>
                        <b>Question:</b> <em>{question}</em>
                    </p>
                    <p>
                        <b>Option1:</b> <em>{option1}</em>
                    </p>
                    <p>
                        <b>Option2:</b> <em>{option2}</em>
                    </p>
                    <p>
                        <b>Option3:</b> <em>{option3}</em>
                    </p>
                    <p>
                        <b>Option4:</b> <em>{option4}</em>
                    </p>
                    <p>
                        <b>Answer:</b> <em>{answer}</em>
                    </p>
                    <p>
                        <b>Reference:</b> <em>{reference}</em>
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={close}>
                        Edit
                    </Button>
                    <Button
                        positive
                        icon="checkmark"
                        labelPosition="right"
                        content="Ok"
                        onClick={checkInput}
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default PreviewModal;
